/**
 * PurchaseManagerAnalyticsModule
 *
 * Import this module in PurchaseManagerModule.
 * All services are provided at module level (not root) so that the
 * analytics system lifecycle is scoped to purchase-manager usage.
 */
import { ModuleWithProviders, NgModule } from '@angular/core';

import { DEFAULT_ANALYTICS_CONFIG } from './constants/analytics.constants';
import { AnalyticsConfig } from './models/analytics.interfaces';
import { AnalyticsEventBuilder } from './services/analytics-event-builder.service';
import { AnalyticsStorageService } from './services/analytics-storage.service';
import { AnalyticsSyncService } from './services/analytics-sync.service';
import { FunnelTrackingService } from './services/funnel-tracking.service';
import { PurchaseManagerAnalyticsService } from './services/purchase-manager-analytics.service';

@NgModule({})
export class PurchaseManagerAnalyticsModule {
    /**
     * Use forRoot() in PurchaseManagerModule to provide all analytics services.
     * Optional config overrides the defaults.
     */
    static forRoot(
        config?: Partial<AnalyticsConfig>
    ): ModuleWithProviders<PurchaseManagerAnalyticsModule> {
        return {
            ngModule: PurchaseManagerAnalyticsModule,
            providers: [
                AnalyticsStorageService,
                AnalyticsEventBuilder,
                AnalyticsSyncService,
                FunnelTrackingService,
                PurchaseManagerAnalyticsService,
                {
                    provide: 'ANALYTICS_CONFIG',
                    useValue: { ...DEFAULT_ANALYTICS_CONFIG, ...config },
                },
            ],
        };
    }
}
